import toString from './to-string';
var lowerCase = function (str) {
    return toString(str).toLowerCase();
};
export default lowerCase;
//# sourceMappingURL=lower-case.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/lower-case.js
// module id = 503
// module chunks = 3